import { component } from 'picoapp';
import formatMoney from 'utils/format-money';
import { adding, added } from 'utils/add-to-cart-text';

export default component(async (node: HTMLFormElement) => {
  const submit = node.querySelector<HTMLButtonElement>('[data-submit]');
  const quantities = node.querySelectorAll<HTMLInputElement>('input[name="items[][quantity]"]');
  const countElement = node.querySelector('[data-count]');
  const totalInclVatElement = node.querySelector('[data-total-incl-vat]');
  const totalExclVatElement = node.querySelector('[data-total-excl-vat]');
  const totalVatElement = node.querySelector('[data-total-vat]');
  const totalSavingsContainer = node.querySelector<HTMLElement>('[data-savings-container]');
  const totalSavingsElement = node.querySelector('[data-total-savings]');

  const updateContent = () => {
    const total = [...quantities].reduce(
      (acc, current) => acc + parseInt(current.dataset.price, 10) * current.valueAsNumber,
      0,
    );

    const totalSavings = [...quantities].reduce((acc, current) => {
      const savings = Math.max(
        parseInt(current.dataset.compareAtPrice, 10) - parseInt(current.dataset.price, 10),
        0,
      );

      return acc + savings * current.valueAsNumber;
    }, 0);

    const count = [...quantities].reduce((acc, current) => acc + current.valueAsNumber, 0);

    if (totalInclVatElement) totalInclVatElement.textContent = formatMoney(total).toString();
    if (totalExclVatElement) totalExclVatElement.textContent = formatMoney(total / 1.25).toString();
    if (totalVatElement) totalVatElement.textContent = formatMoney(total * 0.2).toString();
    totalSavingsContainer.hidden = totalSavings === 0;
    totalSavingsElement.textContent = formatMoney(totalSavings).toString();
    countElement.textContent = count.toString();
  };

  updateContent();
  quantities.forEach((quantity) => {
    quantity.addEventListener('change', updateContent);
  });

  node.addEventListener('submit', async (event) => {
    event.preventDefault();

    adding(submit);

    await fetch(`${node.action}.js`, {
      method: node.method,
      body: new FormData(node),
    });

    added(submit);

    const evt: CustomEvent<{ image: string | null; }> = new CustomEvent('cart:product:added');
    document.dispatchEvent(evt);
  });
});
